(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-multicolumn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var accordionButtons = document.querySelectorAll(".collapsible-section .toggle-button");

  accordionButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      var collapse = this.closest(".multicolumn-card").querySelector(".collapse");


      if (!collapse.classList.contains("show")) {
        slideDown(collapse);
        collapse.classList.add("show");
      } else {
        slideUp(collapse);
        collapse.classList.remove("show");
      }
    });
  });

  function slideUp(element) {
    element.style.maxHeight = element.scrollHeight + "px";
    setTimeout(function () {
      element.style.maxHeight = 0;
      setTimeout(function () {
        element.style.display = "none";
      }, 300); // Wait for the transition to complete before hiding
    }, 100);
  }

  function slideDown(element) {
    element.style.display = "block";
    element.style.maxHeight = element.scrollHeight + "px";
    setTimeout(function () {
      element.style.maxHeight = "unset";
    }, 100);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupons-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var expiries = document.querySelectorAll(".card-wrapper .expiry");
    var headerBoxLinks = document.querySelectorAll(".header-box .link");
    var copyCodeButtons = document.querySelectorAll(".card-wrapper .copy-code");
    expiries.forEach(function(expiry) {
      var dateString = expiry.value;
      var datetime = new Date(dateString);

      // Set time to end of the day
      datetime.setHours(23);
      datetime.setMinutes(59);
      datetime.setSeconds(59);
      datetime.setMilliseconds(999);

      var currentTime = new Date();

      var isPast = datetime < currentTime;
      if (isPast){
        expiry.closest('.card-wrapper').classList.add('expired');
      }
    });
    var coupons = document.querySelectorAll(".coupons .card-wrapper");
    var expiredCoupons = document.querySelectorAll(".coupons .card-wrapper.expired");
    console.log(coupons.length, expiredCoupons.length);
    if(coupons.length === expiredCoupons.length){
      var noCoupons = document.querySelector(".coupons .no-coupons");
      noCoupons.classList.remove("hide");
    }
    headerBoxLinks.forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault();
        var type = this.value;
        var activeLink = document.querySelector(".header-box .active");
        if(activeLink){
          activeLink.classList.remove("active");
        }
        this.classList.add("active");
        var coupons = document.querySelectorAll(".coupons .card-wrapper");
        if(type === "all") {
          coupons.forEach(function(item){
            item.classList.remove("hide");
          });
          var hiddenCoupons = document.querySelectorAll(".coupons .card-wrapper.hide");
          var noCoupons = document.querySelector(".coupons .no-coupons");
          if(coupons.length === hiddenCoupons.length){
            noCoupons.classList.remove("hide");
          } else {
            noCoupons.classList.add("hide");
          }
        } else {
          coupons.forEach(function(item){
            item.classList.add("hide");
          });
          var typeCoupons = document.querySelectorAll(`.coupons .${type}`);
          typeCoupons.forEach(function(item){
            item.classList.remove("hide");
          });
          var typeHiddenCoupons = document.querySelectorAll(`.coupons .${type}.hide`);
          var noCoupons = document.querySelector(".coupons .no-coupons");
          if(typeCoupons.length === typeHiddenCoupons.length){
            noCoupons.classList.remove("hide");
          } else {
            noCoupons.classList.add("hide");
          }
        }
      });
    });

    copyCodeButtons.forEach(function(copy) {
      copy.addEventListener("click", function(e) {
        e.preventDefault();
        var code = this.value;
        navigator.clipboard.writeText(code)
        .then(function() {
          alert("Coupon Code copied successfully:");
        })
        .catch(function(error) {
          console.error("Unable to copy code:", error);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-mobile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var accordionButtons = document.querySelectorAll(".accordion .btn-toggle");

    accordionButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        var icon = this.querySelector(".gsi");
        var collapse = this.closest(".item").querySelector(".collapse");

        document.querySelectorAll(".accordion .btn-toggle .gsi.gs-chevron-up").forEach(function(upIcon) {
          upIcon.classList.add("gs-chevron-down");
          upIcon.classList.remove("gs-chevron-up");
        });

        if (! collapse.classList.contains("show")) {
          document.querySelectorAll(".collapse.show").forEach(function(shownCollapse) {
            slideUp(shownCollapse);
            shownCollapse.classList.remove("show");
          });

          slideDown(collapse);
          collapse.classList.add("show");
          icon.classList.add("gs-chevron-up");
          icon.classList.remove("gs-chevron-down");
        } else {
          slideUp(collapse);
          collapse.classList.remove("show");
          icon.classList.add("gs-chevron-down");
          icon.classList.remove("gs-chevron-up");
        }
      });
    });
    function slideUp(element) {
      element.style.transition = "max-height 0.3s";
      element.style.maxHeight = element.scrollHeight + "px";
      element.style.overflow = "hidden";
      setTimeout(function() {
        element.style.maxHeight = 0;
        setTimeout(function() {
          element.style.display = "none";
        }, 300); // Wait for the transition to complete before hiding
      }, 100);
    }
    function slideDown(element) {
      element.style.transition = "max-height 0.3s";
      element.style.display = "block";
      element.style.overflow = "hidden";
      element.style.maxHeight = element.scrollHeight + "px";
      setTimeout(function() {
        element.style.maxHeight = "unset";
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-top"] && !Shopify.designMode) return;
  try {
    
  /* Yotpo review badge * /
  var yotpo_app_key = 'CvekGnxwoARDv2TIkrsamQxTKKuMvMgSSMeS2u2F';

  (function e() {
    var e = document.createElement('script');
    (e.type = 'text/javascript'),
    (e.async = true),
    (e.src = '//staticw2.yotpo.com/CvekGnxwoARDv2TIkrsamQxTKKuMvMgSSMeS2u2F/widget.js');
    var t = document.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(e, t);
  })();
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-matchmaker"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const startQuiz = document.querySelector('.matchmaker-section .btn-start-quiz');
    const previousBtn = document.querySelector('.matchmaker-section .btn-previous');
    const prev = document.querySelector('.matchmaker-section .quiz-navigation .prev');
    const next = document.querySelector('.matchmaker-section .quiz-navigation .next');
    const finish = document.querySelector('.matchmaker-section .quiz-navigation .finish');
    const btnQuizOption = document.querySelectorAll('.matchmaker-section .btn-quiz-option');
    let step = 1;

    startQuiz.addEventListener('click', function() {
      const leftArea = document.querySelector('.matchmaker-section .left-area');
      const rightArea = document.querySelector('.matchmaker-section .right-area');
      if (leftArea && rightArea) {
        leftArea.classList.add('quiz-started');
        rightArea.classList.add('start');
      }
    });

    previousBtn.addEventListener('click', function() {
      if (step > 1) {
        prev.click();
      }
    });

    btnQuizOption.forEach(function(button) {
      button.addEventListener('click', function() {
        const activeQuestionBlock = this.closest('.question-blok');
        if (activeQuestionBlock) {
          const activeOption = activeQuestionBlock.querySelector('.btn-quiz-option.active');
          if (activeOption) {
            activeOption.classList.remove('active');
          }
          activeQuestionBlock.querySelector('.question-value').value = this.value;
          this.classList.add('active');
          if (document.querySelector('.matchmaker-section .right-area').classList.contains('start')) {
            if (step === 4) {
              finish.click();
            } else {
              next.click();
            }
          }
        }
      });
    });

    prev.addEventListener('click', function() {
      if (step > 1) {
        document.getElementById(`question-${step}`).classList.remove('active');
        document.querySelector(`.progress-wrapper .bar`).classList.remove(`progress-${step}`);
        step = step - 1;
        document.querySelector(`.step-${step}`).classList.add('active');
        document.getElementById(`question-${step}`).classList.add('active');
        document.querySelector(`.progress-wrapper .bar`).classList.add(`progress-${step}`);
      }
      if (step < 2) {
        prev.disabled = true;
      } else {
        prev.disabled = false;
      }
      if (step < 4) {
        finish.style.display = 'none';
        next.style.display = 'inline-block';
      }
    });

    next.addEventListener('click', function() {
      if (step < 4) {
        document.getElementById(`question-${step}`).classList.remove('active');
        document.querySelector(`.progress-wrapper .bar`).classList.remove(`progress-${step}`);
        step = step + 1;
        document.querySelector(`.step-${step}`).classList.add('active');
        document.getElementById(`question-${step}`).classList.add('active');
        document.querySelector(`.progress-wrapper .bar`).classList.add(`progress-${step}`);
      } else { // finish
        finish.style.display = 'inline-block';
        const formData = new FormData();
        console.log('finish', 'filter.p.tag');
      }
      if (step > 1) {
        prev.disabled = false;
      } else {
        prev.disabled = true;
      }
      if (step === 4) {
        finish.style.display = 'inline-block';
        next.style.display = 'none';
      }
    });

    finish.addEventListener('click', function(e) {
      e.preventDefault();
      let valid = true;
      const tags = [];
      document.querySelectorAll('.question-value').forEach(function(input) {
        if (input.value === '') {
          valid = false;
        } else {
          tags.push(input.value);
        }
      });
      if (! valid) {
        alert('Please select all options');
        return;
      }

      const tagsString = tags.join('+');
      const redirectUrl = `/collections/all-mattresses/${tagsString}`;

      document.querySelectorAll(`.progress-wrapper .bar`).forEach(function(bar) {
        bar.classList.remove(`progress-4`);
        bar.classList.add(`progress-5`);
      });
      document.querySelector(`.matchmaker-section`).classList.add(`please-wait`);
      prev.disabled = true;
      finish.disabled = true;

// Redirect to the new URL
      window.location.href = redirectUrl;
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('.product-content .tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      var href = this.getAttribute('href');
      var activeTab = document.querySelector('.product-content .tabs .tab.active');
      var activeTabContent = document.querySelector('.product-content .tab-content .tab-pane.active');
      if (activeTab) {
        activeTab.classList.remove('active');
      }
      if (activeTabContent) {
        activeTabContent.classList.remove('active');
      }
      this.classList.add('active');
      document.querySelector(href).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
